/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import './OrderBasicInfoV1.scss';
import { CopyText } from '../../../../UiKit';
import { AppDetails } from '../../../tooltip';
import Shimmer from 'sushiweb/Shimmer';
import { getFullDate } from '../../../commons/CommonMethods';
import { OrdersInSameCartModal } from './OrdersInCartModal';
import OrderTags from './OrderTags';
import OrderActionWidget from '../../../lifeline/header/OrderActionWidget';
import { PreviousIssuesV1 } from '../../../popups/PreviousIssuesModal/PreviousIssuesModalV1';
import { orderModel } from '../../../../api';
import OrderAdditionalInfo from '../../../../containers/lifeline/orderAdditionalInfo';
import { TabletSmartphone } from 'lucide-react';
import Comments from '../../../../containers/lifeline/comments';
import { ToolTip } from '../../../ComponentsV1/ToolTip/Tooltip';

const dashboardMode = window.dashboard.mode;

export const LineDivider = ({ height = '100%' }) => (
  <div className='tw-flex tw-items-center tw-justify-center tw-mx-4'>
    <div
      className='tw-h-[2px] tw-w-[1.5px] tw-bg-zinc-400 tw-opacity-70 tw-rounded-sm'
      style={{ height }}
    />
  </div>
);

export const OrderBasicInfoV1 = (props) => {
  const {
    orderId = null,
    userId = null,
    cartId = null,
    order = null,
    orderBasicInfo,
    reloadOrder,
    openHelpSectionPopUp,
    openCallLogsModal,
    showIssueBox = () => {},
    getTransactionsDetails = () => {},
    setTransactionDetails = () => {},
    isRestrictedDeletedOrder = false,
    showCopilotView = () => {},
  } = props;
  const [isVisible, setVisible] = useState();
  const [refundSummary, setRefundSummary] = useState();

  useEffect(() => {
    fetchTransactionDetails();
  }, [orderId, cartId, userId]);

  const handleClose = () => setVisible(false);

  const fetchTransactionDetails = () => {
    orderModel
      .getTransactionsDetails({
        order_id: orderId,
        cart_id: cartId,
        customer_id: userId,
      })
      .then((res) => {
        setTransactionDetails(res);
        setRefundSummary(res?.refund_summary);
      });
  };

  const getTranscrtionStr = (refund_summary) => {
    if (!refund_summary) return null;
    let str = '';
    if (refund_summary?.is_refunded) {
      str = (
        <p
          className='red tw-text-300 tw-font-medium tw-cursor-pointer tw-bg-red-200/40 tw-px-2 tw-rounded-[6px] hover:tw-bg-red-200/60 hover:tw-transition-all
        tw-ease-in-out tw-duration-200 tw-border-solid tw-border-red-200 tw-border-[1px] tw-whitespace-nowrap
        '
        >
          {refund_summary?.display_total} refunded
        </p>
      );
    } else {
      str = (
        <p className='tw-text-base-green tw-text-[1.4rem] tw-font-medium tw-cursor-pointer'>
          Transactions
        </p>
      );
    }
    return str;
  };

  return (
    <div className='basicInfoContainerV1'>
      <OrdersInSameCartModal
        isVisible={isVisible}
        handleClose={handleClose}
        cartId={order?.cart_id}
      />

      {!order ? (
        <Shimmer height='6rem' width='100%' />
      ) : (
        <div
          className={`orderIdInfo ${
            dashboardMode === 'lifelineZ' ? dashboardMode : 'tw-gap-2'
          } tw-gap-5`}
        >
          <div className='orderId tw-flex tw-items-start tw-justify-between tw-w-full'>
            <div className='tw-flex tw-items-center tw-gap-2'>
              {/* Device details */}
              {order?.app_details && (
                <ToolTip
                  className='!tw-bg-white'
                  closeDelay={'100'}
                  placement='right'
                  content={
                    <AppDetails
                      appDetails={order.app_details}
                      deviceDetails={order.device_details}
                    />
                  }
                >
                  <div className='tw-cursor-pointer'>
                    <TabletSmartphone
                      size={16}
                      className={`${
                        order.device_details?.is_blocked
                          ? 'tw-text-[#FF0000]'
                          : 'tw-text-zinc-700'
                      }`}
                      strokeWidth={2.2}
                    />
                  </div>
                </ToolTip>
              )}
              {/* Order ID */}
              {order.order_id && (
                <div
                  className='tw-text-zinc-700 tw-mr-1'
                  css={`
                    & span {
                      font-size: 1.9rem;
                      font-weight: 600;
                    }
                  `}
                >
                  <span className='tw-text-600 tw-mr-1 tw-whitespace-nowrap'>
                    Order #
                  </span>
                  <CopyText title={order.order_id} />
                </div>
              )}
              {/* Order Tags */}
              <OrderTags order={order} />
            </div>

            {!isRestrictedDeletedOrder && (
              <OrderActionWidget
                openCallLogsModal={openCallLogsModal}
                reloadOrder={reloadOrder}
                orderId={orderId}
                userId={userId}
                orderBasicInfo={orderBasicInfo}
                openHelpSectionPopUp={openHelpSectionPopUp}
                showIssuesBox={showIssueBox}
                showCopilotView={showCopilotView}
              />
            )}
          </div>

          <div className='tw-flex tw-justify-between tw-items-center'>
            <div className='lighter date tw-text-200 tw-text-grey-900 tw-font-regular tw-flex'>
              <div className='tw-text-400 tw-font-medium tw-text-zinc-600'>
                {getFullDate(order.created_at)}
              </div>
              <LineDivider height='16px' />
              <div className='tw-text-400 tw-font-medium tw-text-zinc-600'>
                <span className='tw-mr-1'>{'ORD #'}</span>
                <CopyText title={order.gr_id} />
              </div>
              <LineDivider height='16px' />

              <div>
                <ToolTip
                  content={'Click to view Linked orders'}
                  placement='bottom'
                >
                  <span
                    onClick={() => setVisible(true)}
                    className='tw-cursor-pointer tw-text-400 tw-font-medium tw-mr-2 tw-text-zinc-600 hover:tw-text-base-green tw-transition-all tw-duration-200 tw-ease-in-out'
                    style={{
                      textDecoration: 'underline dashed',
                      textUnderlineOffset: '4px',
                    }}
                  >
                    Cart
                  </span>
                </ToolTip>
                <div className='tw-text-400 tw-font-medium tw-text-zinc-600 tw-flex tw-gap-1'>
                  # <CopyText title={order.cart_id} />
                </div>
              </div>
            </div>

            {!isRestrictedDeletedOrder && (
              <div className='additionalInfo tw-justify-end tw-items-center'>
                <OrderAdditionalInfo
                  showAddTagOnly
                  orderId={orderId}
                  userId={userId}
                  cartId={cartId}
                  orderBasicInfo={orderBasicInfo}
                />
                <LineDivider height='16px' />

                <PreviousIssuesV1 orderId={orderId} />

                <LineDivider height='16px' />

                <Comments
                  cartId={cartId}
                  orderId={orderId}
                  showOnlyBtn={true}
                />

                {refundSummary && <LineDivider height='16px' />}

                <p onClick={getTransactionsDetails}>
                  {getTranscrtionStr(refundSummary)}
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
